<template>
  <div>
    <div class="row shadow-none">
      <div class="col">
        <div :class="[{ 'be-loading-active': isBusy }]">
          <div
            class="w-full flex flex-col md:flex-row justify-between md:items-center flex-wrap mb-[16px]"
          >
            <button
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px] border-b-2 border-[#2463EB] text-[#2463EB] max-w-max"
            >
              All Customers
            </button>
            <div
              class="flex gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center mt-[10px] md:mt-0"
            >
              <button
                @click="viewFilter"
                class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
              >
                <span class="">
                  <img src="/assets/icon/sort.svg" alt="" />
                </span>
                Filters
              </button>
              <!-- <button
                v-if="hasPermission('Global_View_Customers')"
                class="btn btn-info btn-rounded"
                @click.prevent="viewGlobal"
              >
                <span>
                  <i class="mdi mdi-earth text-white"></i>
                  Switch to {{ isGlobal ? "Default" : "Global" }}
                </span>
              </button> -->
              <button
                class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
                @click="viewAdd"
                v-if="hasPermission('Customer_Create')"
              >
                <i class="feather icon-plus"></i> &nbsp;New customer
              </button>
            </div>
          </div>

          <!-- table -->

          <div class="table-responsive">
            <table class="table dataTable text-nowrap m-0 p-0 min-h-[180px]">
              <thead class="bg-white">
                <tr>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Name
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Branch
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Email
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Account Balance
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Account Manager
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Registration Status
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr v-if="loading">
                  <td colspan="12" class="text-center">
                    <div
                      class="text-center"
                      style="padding-top: 100px; padding-bottom: 50px"
                    >
                      <span
                        class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                        style="font-size: 8rem"
                      ></span>
                      <h3
                        class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                        style="padding-bottom: 100px"
                      >
                        Please wait while we load the list
                      </h3>
                    </div>
                  </td>
                </tr>
                <tr v-for="u in salesReps" :key="u.id" v-else>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ u.displayName }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ u.branch ? u.branch.name : "N/A" }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ u.emailAddress }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ formatMoney(u.accountBalance) }}
                  </td>
                  <td
                    class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
                  >
                    {{ u.introducer ? u.introducer.displayName : "N/A" }}
                  </td>
                  <td>
                    <span
                      :class="[
                        'badge',
                        {
                          'badge-primary': u.status == 'Pending',
                        },
                        {
                          'badge-success': u.status == 'Active',
                        },
                        {
                          'badge-danger': u.status == 'Inactive',
                        },
                      ]"
                    >
                      <span
                        class="inline-block w-[10px] h-[10px] rounded-[1px]"
                        :style="{
                          backgroundColor:
                            u.status === 'Active'
                              ? '#16a249'
                              : u.status === 'Inactive'
                              ? '#e42728'
                              : u.status === 'Pending'
                              ? '#7367F0'
                              : '',
                        }"
                      >
                      </span>
                      <span class="text-[12px] font-normal leading-[16.94px]">
                        {{
                          u.status == "Pending"
                            ? "Invitation sent"
                            : u.status == "Active"
                            ? "Active"
                            : u.status
                        }}
                        <!-- {{ u }} -->
                      </span>
                    </span>
                  </td>
                  <td>
                    <div class="dropdown">
                      <button
                        class="btn-no-border"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span
                          class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                        >
                          ...
                        </span>
                      </button>
                      <ul
                        class="dropdown-menu shadow-none"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          href="#"
                          @click.prevent="
                            tempCustomerId = null;
                            details(u.id);
                          "
                        >
                          View Customer Details
                        </li>
                        <li
                          v-if="hasPermission('View_Customer_Account')"
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          @click.prevent="viewCustomerAccount(u.id)"
                        >
                          View Customer Account
                        </li>
                        <li
                          v-if="hasPermission('Orders_Create')"
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          @click="OrderCreate(u.id)"
                        >
                          Order shortcut
                        </li>
                        <li
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                          @click.prevent="viewResend(u)"
                          v-if="
                            u.status == 'Pending' &&
                              hasPermission('Customer_Send_Invite')
                          "
                        >
                          Resend Invite
                        </li>
                        <li
                          class="text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                          :class="{
                            'border-b':
                              u.status == 'Pending' &&
                              hasPermission('Customer_Delete'),
                          }"
                          v-if="hasPermission('Customer_Enable_Disable')"
                          @click.prevent="viewRemove(u)"
                        >
                          {{ u.status == "Inactive" ? "Enable" : "Disable" }}
                        </li>
                        <li
                          v-if="
                            u.status == 'Pending' &&
                              hasPermission('Customer_Delete')
                          "
                          class="text-[14px] font-normal leading-[14px] cursor-pointer py-[10px] px-[16px]"
                          @click.prevent="confirmDelete(u.id)"
                          style="color: red"
                        >
                          Delete Customer
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr v-if="!salesReps.length && !loading">
                  <td colspan="8">
                    <div class="text-center" style="padding-top: 50px">
                      <span
                        style="font-size: 4.615rem"
                        class="mdi mdi-account-card-details"
                      ></span>
                    </div>
                    <h3 class="text-center" style="padding-bottom: 100px">
                      You don't have any customers.
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination
              :limit="pageSize"
              :count="pageCount"
              :page="page"
              :itemsCount="count"
              @changePage="gotoPage"
              @changeLimit="changeLimit"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-geotag-details"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h3 class="modal-title">
              Geo-Tag Information -
              {{ geoTagDetails ? geoTagDetails.storeName : "" }}
            </h3>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body" v-if="!geoTagDetails.storeName">
            <div class="form-group row">
              <div class="col-12 col-sm-12 col-lg-12 text-center">
                <span class="col-12 alert alert-primary"
                  ><i class="fa fa-spinner fa-spin"></i> Please wait...</span
                >
              </div>
            </div>
          </div>
          <div class="modal-body" v-else>
            <div class="form-group row">
              <div
                class="col-12 col-sm-12 col-lg-12"
                v-if="geoTagDetails.storeImageString"
              >
                <img
                  style="
                    margin: auto;
                    display: block;
                    border: 2px solid #eee;
                    border-radius: 10px;
                    width: 200px;
                    height: auto;
                  "
                  v-bind:src="geoTagDetails.storeImageString"
                />
              </div>
              <div class="col-12 col-sm-12 col-lg-12" v-else>
                <img
                  style="margin: auto; display: block; width: 100px; height: auto"
                  src="/assets/img/avatar.png"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Store Name</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  class="form-control"
                  type="text"
                  disabled
                  v-model="geoTagDetails.storeName"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Longitude</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  class="form-control"
                  type="text"
                  disabled
                  v-model="geoTagDetails.longitude"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Latitude</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  class="form-control"
                  type="text"
                  disabled
                  v-model="geoTagDetails.latitude"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Geo-Tag Date</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  class="form-control"
                  type="text"
                  disabled
                  v-model="geoTagDetails.tagDate"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Created By</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  class="form-control"
                  type="text"
                  disabled
                  v-model="geoTagDetails.createdBy"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary md-close"
              type="button"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
              @click="reset"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select2
                  placeholder="Select an option"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  v-model="filter.status"
                >
                  <option value="0">All Customers</option>
                  <option value="active">Active</option>
                  <option value="inactive">Disabled</option>
                  <option value="pending">Others</option>
                </select2>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Customer Type</label
              >
              <div>
                <select2
                  placeholder="Select an option"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  v-model="filter.customerType"
                >
                  <option value="0">All Customers</option>
                  <option value="In-house">In-house</option>
                  <option value="Community">Community</option>
                </select2>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div class="">
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by name, email"
                  v-model="filter.qry"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Mobile Number</label
              >
              <div class="flex gap-0 items-start">
                <select
                  v-model="selectedCountryCode"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-r-[8px] w-[20%] outline-none"
                  disabled
                >
                  <option
                    v-for="code in countryCodes"
                    :key="code"
                    :value="code"
                  >
                    {{ code }}
                  </option>
                </select>
                <input
                  type="number"
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-l-[6px] w-[80%] outline-none"
                  id="mobileNumber"
                  placeholder="Enter mobile number"
                  v-model="filter.phoneNumber"
                  @input="validateMobileNumber"
                />
              </div>
              <small v-if="validationError" class="text-danger">{{
                validationError
              }}</small>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Sort by</label
              >
              <div>
                <select2
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.sortColumn"
                >
                  <option value="name">Name</option>
                  <option value="status">Registration Status</option>
                  <option value="customertype">Customer Type</option>
                </select2>
              </div>
            </div>
            <div>
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Sort Direction</label
              >
              <div>
                <select2
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.sortDirection"
                >
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select2>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getCustomers"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>

    <invite-customer @onInviteComplete="onInviteCompleteHandler" />

    <div class="modal fade" id="mod-delete" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              {{ modalUser.status == "Inactive" ? "enable" : "disable" }}
            </h4>
            <button
              class="text-2xl text-[#353535] border-solid border-[#353535] border-[1.5px] rounded-full px-[4px]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <p class="text-[#96a0b5] text[14px] font-normal leading-[20px]">
              Are you sure you want to
              <span class="font-semibold">
                {{ modalUser.status == "Inactive" ? "enable" : "disable" }}
              </span>
              this customer:
              <span class="font-semibold">
                {{ modalUser.displayName || modalUser.emailAddress }}
              </span>
            </p>
          </div>
          <div class="mt-[16px] flex items-center gap-[8px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[14px] sm:text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[14px] sm:text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="updateStatus"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Yes, proceed</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-resend" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div
            class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
          >
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Resend Invite
            </h4>
            <button
              class="text-2xl text-[#353535] border-solid border-[#353535] border-[1.5px] rounded-full px-[4px]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <p class="text-[#96a0b5] text[14px] font-normal leading-[20px]">
              You are about to resend an invite to this customer:
              <span class="font-semibold">
                {{ modalUser.displayName || modalUser.emailAddress }}
              </span>
            </p>
            <div v-if="enableInviteOption" class="">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
              ></label>
              <div>
                <div
                  class="custom-control custom-radio"
                  :class="[{ 'is-invalid': v4.selectedOption }]"
                  v-for="option in inviteOptions"
                  :key="option.value"
                >
                  <input
                    type="radio"
                    :id="option.value"
                    name="customRadio"
                    class="custom-control-input"
                    :value="option.value"
                    v-model="selectedOption"
                  />
                  <label class="custom-control-label" :for="option.value">
                    {{ option.name }}
                  </label>
                </div>
                <ul v-if="v4.selectedOption" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="mt-[16px] flex items-center gap-[8px]">
            <button
              type="button"
              data-dismiss="modal"
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[14px] sm:text-[16px] font-medium leading-[20px] w-full"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[14px] sm:text-[16px] font-medium leading-[20px] w-full"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="attemptResendInvite"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Yes, proceed</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-update-credit"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h3 class="modal-title">
              Set credit limits for {{ updatingCustomer.displayName }}
            </h3>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Credit Limit</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <label
                  class="custom-control custom-checkbox custom-control-inline"
                >
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    v-model="updatingCustomer.hasCredit"
                  />
                  <span class="custom-control-label"
                    >This customer has access to credit facilities</span
                  >
                </label>
              </div>
            </div>
            <div class="form-group row" v-if="updatingCustomer.hasCredit">
              <label
                class="col-12 col-sm-3 col-form-label text-sm-right"
              ></label>
              <div class="col-12 col-sm-8 col-lg-8">
                <input
                  :class="['form-control', { 'is-invalid': v3.creditLimit }]"
                  type="number"
                  v-model="updatingCustomer.creditLimit"
                />
                <ul v-if="v3.creditLimit" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a valid number.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 100px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="updateCreditLimits"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- global -->
    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-global"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <h3 class="p-1">Confirmation</h3>
              <p>
                Do you want to switch to
                {{ isGlobal ? "Default" : "Global" }} View?
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 140px"
              :disabled="isBusyModal"
              class="btn btn-warning"
              type="button"
              @click.prevent="toggleGlobal"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Yes, proceed</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteCustomer"
      :isBusy="isBusyModal"
      text="customer"
    />
    <GeneralDeleteMessage
      message='You cannot delete this customer because there is a payment or order transaction history associated with the customer. Consider disabling the customer instead"'
    />
    <customerModal
      :activeTab="activeTab"
      :closeModal="closeModal"
      :switchTab="switchTab"
      v-if="isModalVisible"
      :customerId="customerId"
      :customer="customer"
    />

    <div class="modal fade py-1" id="mod-success-invite" role="dialog">
      <div class="modal-dialog max-w-[550px] mx-auto w-full relative">
        <div class="modal-content p-[10px] md:p-[20px] bg-[#f8f8f8]">
          <button
            class="absolute right-6 top-4 text-2xl outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
          <div class="text-center">
            <div class="flex justify-center items-center my-[16px]">
              <img src="/assets/img/tick-circle (1).png" alt="" />
            </div>

            <p class="text-[16px] font-bold text-[#353535] mb-[4px] md:mx-2">
              User Invited Successfully
            </p>
            <p class="text-[14px] font-normal text-[#96a0b5] md:mx-2">
              You have successfully invited this user
            </p>
            <div class="flex items-center justify-center gap-[8px] mt-[16px]">
              <button
                type="button"
                data-dismiss="modal"
                aria-hidden="true"
                class="border border-solid border-[#96a0b5] rounded-[8px] text-[#96a0b5] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[16px] w-full outline-none focus:outline-none"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import SystemPermissions from "@/permissions";
import InviteCustomer from "../components/User/InviteCustomer.vue";
import Pagination from "../components/Pagination.vue";
import customerModal from "../components/Customer/customerModal.vue";
import { bus } from "../main";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "salesReps",
  components: {
    Select2,
    InviteCustomer,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    customerModal,
  },

  data() {
    return {
      isModalVisible: false,
      activeTab: "info",
      filter: {
        status: "0",
        customerType: "0",
        qry: "",
        phoneNumber: "",
        sortColumn: "name",
        sortDirection: "asc",
        showForMe: false,
      },

      modalUser: {
        emailAddress: null,
        displayName: null,
      },

      updatingCustomer: {},

      v3: {
        creditLimit: false,
      },

      v4: {
        selectedOption: false,
      },

      isBusy: false,
      isBusyModal: false,
      salesReps: [],
      geoTagDetails: {},
      count: 0,
      page: 0,
      isGlobal: false,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      customerExists: false,
      inviteOptions: [
        { name: "SMS", value: "sms" },
        { name: "Email Address", value: "email" },
      ],
      selectedOption: "",
      DeleteId: "",
      countryCodes: ["234"],
      selectedCountryCode: "234",
      mobileNumber: "",
      validationError: "",
      customerId: "",
      customer: {
        parent: {},
        contact: {},
        bank: {},
        groups: [],
        discount: {},
      },
      loading: false,
      tempCustomerId: null,
      createdBy: "",
    };
  },

  created() {
    if (!this.hasPermission("Customer_View")) {
      this.$router.push("/restricted");
    }

    this.isGlobal = true;

    this.getCustomers();
    bus.$on("openCustomerModal", this.openCustomerModal);
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    // loading() {
    //   return this.$store.state.loading;
    // },
    enableInviteOption: function() {
      return this.modalUser.emailAddress && this.modalUser.phoneNumber;
    },
    formattedMobileNumber() {
      let number = this.filter.phoneNumber;
      if (number.startsWith("0")) {
        number = number.slice(1);
      }
      return this.selectedCountryCode + number;
    },
  },

  methods: {
    switchTab(tab) {
      this.activeTab = tab;
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
      this.getCustomers();
    },
    validateMobileNumber() {
      this.validationError = "";
      const regex = /^[0-9]*$/;
      if (!regex.test(this.filter.phoneNumber)) {
        this.validationError = "Please enter a valid mobile number";
      } else if (this.filter.phoneNumber.length < 10) {
        this.validationError = "Mobile number must be at least 10 digits.";
      } else {
        this.$emit("update:mobileNumber", this.formattedMobileNumber);
      }
    },
    reset() {
      this.filter = {
        status: "0",
        customerType: "0",
        qry: "",
        phoneNumber: "",
        sortColumn: "name",
        sortDirection: "asc",
        showForMe: false,
      };
      this.getCustomers();
    },

    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },

    async deleteCustomer() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(
          `/Users/deleteCustomer/${this.DeleteId}`
        );
        if (res.ok) {
          this.$toast.success("Customer deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getCustomers();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    viewAdd() {
      $("#mod-add").modal("show");
    },

    viewRemove(u) {
      this.modalUser = u;
      $("#mod-delete").modal("show");
    },

    viewResend(u) {
      this.modalUser = u;
      $("#mod-resend").modal("show");
    },

    viewCreditLimit(u) {
      this.updatingCustomer = u;
      $("#mod-update-credit").modal("show");
    },

    // viewGlobal() {
    //   $("#mod-global").modal("show");
    // },
    // toggleGlobal() {
    //   $("#mod-global").modal("hide");
    //   this.isGlobal = !this.isGlobal;

    //   this.$auth.setPreferredViewForCustomer(
    //     this.isGlobal ? "global" : "default",
    //     this.user.id
    //   );

    //   this.getCustomers();
    // },
    viewExport() {
      // $("#mod-export").modal("show");
    },

    viewFilter() {
      this.page = 0;
      $("#mod-filter").modal("show");
    },

    onInviteCompleteHandler() {
      $("#mod-add").modal("hide");
      $("#mod-success-invite").modal("show");
      this.getCustomers();
    },

    async attemptResendInvite() {
      if (this.enableInviteOption && this.validateResendInvite())
        this.resendInvite();

      if (!this.enableInviteOption) this.resendInvite();
    },

    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },

    async resendInvite() {
      this.isBusyModal = true;
      await this.$http
        .get(
          "/Users/resendInvite/" +
            this.modalUser.id +
            "?type=" +
            this.selectedOption
        )
        .then(function(res) {
          this.isBusyModal = false;
          if (res.ok && res.body) {
            this.$toast.success("Invite sent successfully.", {
              icon: false,
              rtl: false,
            });
          }
        })
        .catch(function() {
          this.isBusyModal = false;
        });
      $("#mod-resend").modal("hide");
    },

    validateResendInvite() {
      this.v4 = {
        selectedOption: false,
      };

      let isValid = true;

      if (!this.selectedOption) {
        this.v4.selectedOption = true;
        isValid = false;
      }

      return isValid;
    },
    updateCreditLimits() {
      this.isBusyModal = true;

      if (this.validateCreditLimits()) {
        var data = {
          id: this.updatingCustomer.id,
          creditLimit: this.updatingCustomer.creditLimit,
          hasCredit: this.updatingCustomer.hasCredit,
        };

        $("#mod-update-credit").modal("hide");

        this.$http
          .put("/users/updateCreditLimits/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getMerchants();
          })
          .catch(function() {
            this.isBusyModal = false;
          });
      } else {
        this.isBusyModal = false;
      }
    },

    validateCreditLimits() {
      this.v3 = {
        creditLimit: false,
      };
      var isValid = true;

      if (Number(this.updatingCustomer.creditLimit) < 0) {
        this.v3.creditLimit = true;
        isValid = false;
      }

      return isValid;
    },

    updateStatus() {
      this.isBusyModal = true;
      let data = {
        CustomerId: this.modalUser.id,
        Active: this.modalUser.status == "Inactive" ? true : false,
      };
      $("#mod-delete").modal("hide");
      this.$http
        .put("/Users/updateIsActive/" + data.CustomerId, data)
        .then(function(res) {
          this.isBusyModal = false;
          this.getCustomers();
        })
        .catch(function() {
          this.isBusyModal = false;
        });
    },

    async details(id) {
      this.isBusy = true;
      try {
        let newid = id ? id : this.tempCustomerId;
        const res = await this.$http.get("/Users/getById/" + newid);
        this.isBusy = false;
        if (res.ok) {
          this.customer = res.body;
          this.customerId = this.customer.id;
          if (this.tempCustomerId == null) {
            this.activeTab = "info";
          }
          this.isModalVisible = true;
          document.body.style.overflow = "hidden";
        }
      } catch (error) {
        console.log(error);
        this.isBusy = false;
      }
    },
    async viewCustomerAccount(id) {
      this.customerId = id;
      await this.details(this.customerId);
      // this.activeTab = "info";
      this.activeTab = "account";
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    async openCustomerModal(ownerId) {
      this.customerId = ownerId;
      await this.details(this.customerId);
      this.activeTab = "account";
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    OrderCreate(id) {
      this.$router.push({ path: "/orders" }).then(() => {
        bus.$emit("OpenOrderModal", id);
      });
    },
    viewGeoTagDetails(phoneNumber) {
      this.geoTagDetails = {};
      $("#mod-geotag-details").modal("show");
      this.getGeoTagDetails(phoneNumber);
    },

    async getCustomers() {
      this.isBusy = true;
      this.loading = true;
      try {
        const queryParams = [
          `page=${this.page}`,
          `pageSize=${this.pageSize}`,
          `createdBy=${this.user.displayName}`,
          this.filter.status != "0" ? `status=${this.filter.status}` : "",
          this.filter.customerType != "0"
            ? `customerType=${this.filter.customerType}`
            : "",
          this.filter.qry ? `query=${this.filter.qry}` : "",
          this.filter.phoneNumber
            ? `phoneNumber=${this.formattedMobileNumber}`
            : "",
          this.user.parentId ? `parentId=${this.user.parentId}` : "",
          this.filter.sortColumn ? `sortColumn=${this.filter.sortColumn}` : "",
          this.filter.sortDirection
            ? `sortDirection=${this.filter.sortDirection}`
            : "",
          `showForMe=${!this.isGlobal}`,
        ]
          .filter(Boolean)
          .join("&");

        const response = await this.$http.get(
          `/Users/getCustomerList?${queryParams}`
        );
        const data = response.body;
        this.salesReps = data.data;
        this.page = data.page;
        this.pageSize = data.pageSize;
        this.count = data.count;
        this.hasPrev = data.hasPrev;
        this.hasNext = data.hasNext;
        this.pageCount = Math.ceil(data.count / data.pageSize);
      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        this.isBusy = false;
        this.loading = false;
        $("#mod-filter").modal("hide");
      }
    },
    async getGeoTagDetails(phoneNumber) {
      await this.$http
        .get("/Retailers/getByPhoneNumber/" + phoneNumber)
        .then(function(res) {
          var r = res.body;

          var obj = {
            storeName: r.storeName,
            latitude: r.latitude,
            longitude: r.longitude,
            tagDate: this.formatDate(r.created),
            createdBy: r.introducer ? r.introducer.displayName : "",
            storeImageString:
              r.storeImageString && r.storeImageString != ""
                ? "data:image/png;base64," + r.storeImageString
                : "",
          };
          this.geoTagDetails = obj;
        })
        .catch(function() {
          $("#mod-geotag-details").modal("hide");
        });
    },
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    prev() {
      this.page -= 1;
      this.getCustomers();
    },

    next() {
      this.page += 1;
      this.getCustomers();
    },

    gotoPage(page) {
      this.page = page - 1;
      this.getCustomers();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getCustomers();
    },
  },
};
</script>
